import { SETTINGS_GET, SETTINGS_SAVE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";

export const settingsGetApi = () => {
    return apiInstance.get(SETTINGS_GET, {
        headers: authHeader(),
    });
};

export const settingsSaveApi = (payload) => {
    return apiInstance.post(SETTINGS_SAVE, payload, {
        headers: authHeader(),
    });
};
